import React, { useRef, FocusEvent, useState } from "react";
import { Card, Form, Button } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AccountErrorMessages, CreateAccountSteps, CreateAccountUIActionTypes, GlobalConstants, Message, useAppDispatch, MessageHandlerDisplayType, MessageToastTypes } from "src/common";
import { VerificationCode, QRCode } from "src/components";
import { uiActions } from "src/store";
import { authenticator } from "otplib";

type AllProps = {
  user_id: string;
  totp_secret: string;
  handleAction: ActionHandlerFunction;
}

function TOTPFormComponent(props: AllProps) {
  const { user_id, totp_secret, handleAction } = props;
  const dispatch = useAppDispatch();
  const [reset, setReset] = useState<boolean>(false);
  const button_ref = useRef<HTMLButtonElement>(null);
  const otp_uri = authenticator.keyuri(user_id, "PreVeil", totp_secret);
  let totp_code = "";

  // Description: Validate and set secret code on finished
  function handleSetSecretCode(code: string) {
    totp_code = code;
    const button = button_ref.current;
    const is_valid = code.length === GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX;
    if (!!button) {
      button.disabled = !is_valid;
      is_valid && setTimeout(() => button.focus());
    }
    is_valid && handleSubmit();
  }

  // Description: Handle form submit
  function handleSubmit() {
    const is_valid = authenticator.check(totp_code, totp_secret);
    if (is_valid) {
      handleAction({ actionType: CreateAccountUIActionTypes.SubmitTOTPVerificationCode });
    } else {
      // NOTE: Removed the handleRequestErrors because it was causing the incorrect reload of the component
      // Directly reset the Verification control on error
      setReset(true);
      dispatch(uiActions.handleSetMessage(new Message(AccountErrorMessages.bad_totp_code, MessageHandlerDisplayType.toaster, MessageToastTypes.danger)));
    }
  }

  // Description: Render the enter code
  function VerificationForm() {
    return <>
      <h3 className="border-bottom">Time based One-time Password (TOTP) Setup</h3>
      <p>Scan the Quick Response (QR) code below with an authenticator application.</p>
      <Form onSubmit={(e: FocusEvent<HTMLFormElement>) => {
        e.stopPropagation();
        e.preventDefault();
        handleSubmit();
      }} noValidate>
        <Form.Group className="mb-3" >
          <div className="totp-code">
            <QRCode code={otp_uri} width={150} />
          </div>
          <Form.Label>Enter the generated TOTP code below and submit it to PreVeil.</Form.Label>
          <VerificationCode
            count={GlobalConstants.CREATE_ACCOUNT_VERIFICATION_CODE_MAX}
            reset={reset}
            setReset={setReset}
            handleAction={handleSetSecretCode} />
          <Form.Text>
            <details>
              <summary>Unable to scan the QR code?</summary>
              <p>
                If you are unable to scan the code in your authenticator application then enter the following
                secret in the application to get your TOTP code. Then submit the code to PreVeil in the step above
              </p>
              <p className="mb-5"><b>{totp_secret}</b></p>
            </details>
          </Form.Text>
        </Form.Group>
        <div className="btn-panel">
          <Button type="submit" ref={button_ref} disabled={true} >Verify</Button>
          <Button variant="outline-secondary" type="button"
            onClick={() => handleAction({ actionType: CreateAccountUIActionTypes.ChangeStep, params: CreateAccountSteps.PICK_2FA_METHOD })}>Back</Button>
        </div>
      </Form>
    </>;
  }

  return <>
    <Card.Body>
      <VerificationForm />
    </Card.Body>
  </>;
}
export default React.memo(TOTPFormComponent);
